<template>
    <div class="modal fade" id="EditGroupModal" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="EditGroupModalLabel" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="EditGroupModalLabel">Editar Grupo</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="form-group">
                    <label>Programa</label>
                    <select class="form-control" v-model="selectedGrupo.programa_id" @change="selectPrograma">
                        <option disabled selected value="">Selecciona Programa...</option>
                        <option v-for="programa in programas" :key="programa.id" :value="programa.id">{{ programa.text }}</option>
                    </select>
                </div>

                <div class="form-group">
                    <label>Grado</label>
                    <select class="form-control" v-model="selectedGrupo.grado_grupo_id">
                        <option disabled selected value="">Selecciona Grado...</option>
                        <option v-for="grado in grados" :key="grado.id" :value="grado.id">{{ grado.text }}</option>
                    </select>
                </div>

                <div class="form-group">
                    <label>Tipo</label>
                    <select class="form-control" v-model="selectedGrupo.tipo">
                        <option disabled selected value="">Selecciona Tipo...</option>
                        <option value="academico">Académico</option>
                        <option value="administrativo">Administrativo</option>
                        <option value="academico-administrativo">Académico-Administrativo</option>
                    </select>
                </div>

                <div class="form-group">
                    <label>Nombre</label>
                    <input type="text" class="form-control" v-model="selectedGrupo.nombre">
                </div>

                <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" id="editar_flexible" v-model="selectedGrupo.flexible">
                    <label class="custom-control-label" for="editar_flexible">Flexible</label>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>

                <button type="button" class="btn btn-primary" v-if="!saving" @click="save">Guardar</button>

                <button v-if="saving" class="btn btn-primary" type="button" disabled>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    Guardando...
                </button>
            </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    name: 'EditarGrupo',
    inject: ['selectedGrupoChange$', 'programas$', 'gruposRefresh$'],
    mounted() {
        this.programas$.subscribe(programas => this.programas = programas);

        this.selectedGrupoChange$.subscribe(grupo => {
            if (grupo) {
                this.selectedGrupo.grupo_id = grupo.id;
                this.selectedGrupo.nombre = grupo.nombre;
                this.selectedGrupo.programa_id = grupo.programa_id;
                this.selectedGrupo.institucion_id = grupo.institucion_id;
                this.selectedGrupo.grado_grupo_id = grupo.grado_grupo_id;
                this.selectedGrupo.flexible = grupo.flexible;
                this.selectedGrupo.tipo = grupo.tipo;

                this.selectPrograma();
            }
        });
    },
    data() {
        return {
            programas: [],
            grados: [],
            saving: false,
            selectedGrupo: {
                grupo_id: '',
                nombre: '',
                programa_id: '',
                institucion_id: '',
                grado_grupo_id: '',
                flexible: true,
                tipo: ''
            },
        }
    },
    methods: {
        async save() {
            this.saving = true;
            await axios.post('/grupos-administrativos/editarGrupo', this.selectedGrupo).then(resp => resp.data);
            this.saving = false;
            this.gruposRefresh$.next();
            $('#EditGroupModal').modal('hide');
            toastr["success"]('Nuevo grupo académico creado', "Éxito");
        },
        async selectPrograma() {
            this.grados = await axios.get(`/atributos/porPrograma/${this.selectedGrupo.programa_id}`).then(resp => resp.data);
        }
    }
}
</script>

<style>

</style>
